<template>


      <div ripple class="was-it-useful">
        <h3 class="pb-2 pt-1 white--text was-it-useful__heading">{{hubbdata.cmspage.labels.useful}}</h3>
        <v-row no-gutters>
        <v-col
            cols="4"
            sm="4"
            :class="className"
            class="feedback-faces"
        >

        <button @click="sendFeedback('Very useful', 1)" class="d-flex justify-content-center flex-column align-center white--text">
            <v-icon x-large color="white">
                mdi-emoticon-happy
            </v-icon>
            <br />{{hubbdata.cmspage.labels.happy}}
        </button>

        </v-col>
        <v-col
            cols="4"
            sm="4"
            :class="className"
            class="feedback-faces"
        >
        <button @click="sendFeedback('Partly useful', 2)" class="d-flex justify-content-center flex-column align-center white--text">
        <v-icon x-large color="white" >
            mdi-emoticon-neutral
        </v-icon>
        <br />{{hubbdata.cmspage.labels.meh}}
        </button>

        </v-col>
        <v-col
            cols="4"
            sm="4"
            :class="className"
            class="feedback-faces"
        >
        <button @click="sendFeedback('Not useful', 3)" class="d-flex justify-content-center flex-column align-center white--text">
            <v-icon color="white" x-large>
                mdi-emoticon-sad
            </v-icon>
            <br />{{hubbdata.cmspage.labels.sad}}
        </button>
        </v-col>
        </v-row>
    </div>


</template>

<script>
 import hubbdata from "@/hubbdata";



export default {
    name: "WasThisUseful",
    props: {
        type: String
    },
    data: () => ({
        className: '',
    }),
    computed: {
        hubbdata() {
            return hubbdata.getters.translations;
        },
    },
    methods: {
        sendFeedback(response, val) {
                // ga('set', 'title', hubbdata.getters.getOrganisationsById(this.$route.params.id).name); // eslint-disable-line

                if(val === 1) {
                    this.className = 'selected-face-1';
                }
                if(val === 2) {
                    this.className = 'selected-face-2';
                }
                if(val === 3) {
                    this.className = 'selected-face-3';
                }


                if (this.type == 'event') {
                    ga('send', 'event', 'Was this Useful', "Feedback", hubbdata.getters.getEventById(this.$route.params.id).name, response ); // eslint-disable-line

                }
                else if(this.type == 'orgs') {
                    // ga('send', 'event', 'Was this Useful', "Feedback", hubbdata.getters.getOrganisationsById(this.$route.params.id).name, response ); // eslint-disable-line
                    ga('send', { hitType: 'event', eventCategory: 'Organisations', eventAction: response, eventLabel: hubbdata.getters.getOrganisationsById(this.$route.params.id).name}); // eslint-disable-line
                }

                // ga('send', 'event', 'Was this Useful', 'play', 'Fall Campaign');// eslint-disable-line

        },

    },
}

</script>

<style lang="scss">
.col-4 {
text-align: center;
}

.was-it-useful {
  background-color: $primary!important;
  position: relative;
  bottom: -40px;
  border-bottom-left-radius: 0!important;
  border-bottom-right-radius: 0!important;
  padding: 10px 20px 20px;

  &__heading {
    max-width: 750px;
    margin: 0 auto;
  }
}

.emoji-image {
  max-width: 50px;
  max-height: 50px;
}

.feedback-faces {
  display: flex;
  align-items: center;
  justify-content: center;

  button {

    &:focus {
      outline-color: black;
    }
  }
}

.container {

  .selected-face-1:first-of-type .v-icon {
    color: $red !important;
    transition: all 0.5s;
  }

  .selected-face-2:nth-of-type(2) .v-icon {
    color: $red !important;
    transition: all 0.5s;
  }

  .selected-face-3:nth-of-type(3) .v-icon {
    color: $red !important;
    transition: all 0.5s;
  }
}

@media screen and (min-width: 960px) {
  .was-it-useful {

    .no-gutters {
      max-width: 750px;
      margin: auto;
    }
  }
}
</style>
